import { useMutation } from '@tanstack/react-query';
import { useToast } from 'components/Providers/ToastProvider';
import { useSearchAiPluginStore } from 'store/searchAiPluginStore';

type Options = {
    onSuccess?: () => void;
};

const useAISearchMutation = ({ onSuccess }: Options) => {
    const { fetchAiSearchProperties } = useSearchAiPluginStore();
    const { showMessage } = useToast();
    return useMutation({
        mutationKey: ['aiSearchMutation'],
        mutationFn: fetchAiSearchProperties,
        onSuccess: () => {
            if (onSuccess) onSuccess();
        },
        onError: (error) => {
            showMessage('Error Occurred', error.message);
        },
    });
};

export default useAISearchMutation;
